<div class="min-w-[430px] p-6">
  <h2
    class="text-xl font-bold leading-tight text-center tracking-tight text-gray-900 md:text-2xl"
  >
    {{ 'route.name.registration' | transloco }}
  </h2>
  <div class="flex flex-col gap-y-2 my-6">
    <tui-input [formControl]="email" tuiTextfieldSize="l">Email</tui-input>
  </div>
  <button
    [showLoader]="(loading$ | async)!"
    (click)="submit$.next()"
    [disabled]="!email.valid"
    class="w-full"
    tuiButton
    appearance="primary"
  >
    {{ 'auth.sendVerificationMessage' | transloco }}
  </button>
</div>
